import React, { useContext } from 'react'
import { Icon, Popup, PopupProps } from 'semantic-ui-react'
import styled, { ThemeContext } from 'styled-components'

interface Props extends PopupProps {
  content: string
  styleIcon?: any
}

const LinkPopup:React.FC<Props> = ({ content, styleIcon, ...popupProps }) => {
  const { firstColor } = useContext(ThemeContext)

  return <StyleLinkPopup
    content={`Datenquelle: ${content}`}
    trigger={<Icon style={{ ...styleIcon, color: styleIcon?.color || firstColor, fontSize: '1.2em' }} name='chain' />}
    {...popupProps}
  />
}
export default LinkPopup

const StyleLinkPopup = styled(Popup)`
background: ${props => props.theme.firstColor} !important;
color: white !important;
border-radius: 10px !important;
max-width: ${props => props.minWidth}px !important;
cursor: default !important;
`